module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "service-title title is-1"
  }, [_vm._v("Erosion Control")]), _vm._v(" "), _c('affix', {
    scopedSlots: _vm._u([{
      key: "navigation",
      fn: function(props) {
        return [_c('div', {
          ref: "subnav",
          class: {
            'service-navigation': true, 'has-affix': _vm.affixed
          }
        }, [_c('nav', {
          class: {
            'subnav-affix': _vm.affixed
          }
        }, [_c('ul', [_c('li', {
          class: {
            'is-active': props.activeTrigger === 'hydroseeding',
              'has-active': ['hydroseeding', 'soil-preparation', 'watering'].indexOf(props.activeTrigger) !== -1
          }
        }, [_c('a', {
          attrs: {
            "href": "#hydroseeding"
          }
        }, [_vm._v("Hydroseeding")]), _vm._v(" "), _c('ul', {
          staticClass: "subnav"
        }, [_c('li', {
          class: {
            'is-active': props.activeTrigger === 'soil-preparation'
          }
        }, [_c('a', {
          attrs: {
            "href": "#soil-preparation"
          }
        }, [_vm._v("Soil Preparation")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'watering'
          }
        }, [_c('a', {
          attrs: {
            "href": "#watering"
          }
        }, [_vm._v("Watering")])])])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'drillseeding',
              'has-active': ['drillseeding'].indexOf(props.activeTrigger) !== -1
          }
        }, [_c('a', {
          attrs: {
            "href": "#drillseeding"
          }
        }, [_vm._v("Drillseeding")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'silt-fencing',
              'has-active': ['silt-fencing'].indexOf(props.activeTrigger) !== -1
          }
        }, [_c('a', {
          attrs: {
            "href": "#silt-fencing"
          }
        }, [_vm._v("Silt Fencing")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'erosion-control-blankets',
              'has-active': ['erosion-control-blankets'].indexOf(props.activeTrigger) !== -1
          }
        }, [_c('a', {
          attrs: {
            "href": "#erosion-control-blankets"
          }
        }, [_vm._v("Erosion Control Blankets")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'erosion-control-logs',
              'has-active': ['erosion-control-logs'].indexOf(props.activeTrigger) !== -1
          }
        }, [_c('a', {
          attrs: {
            "href": "#erosion-control-logs"
          }
        }, [_vm._v("Erosion Control Logs")])])])])])]
      }
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "service-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "page-section"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "hydroseeding"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Hydroseeding")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v(" \\ hi-dro-seeding \\ (verb)")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            Hydro-what? What in the world is hydro seeding? You've probably seen it but didn't know what to call it.\n                            If you've ever seen what looks like fuzzy green paint along the side of a road or surrounding a new building, you've seen hydro seeding.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            But what does it do? Hydro seed machines mix together seed, water, fertilizer,\n                            tackifier (glue), and green wood fiber mulch to create a slurry. The slurry is\n                            sprayed on the ground with a high pressure hose which helps it to reach all kinds\n                            of terrain, like slopes, that may be difficult to reach. When the slurry dries,\n                            it creates a crust over the ground, protecting the area from erosion.\n                            The crust protects the seeds from being washed away in the rain or eaten by birds.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Grass seed isn't the only type of seed that can be applied this way.\n                            Wildflowers can be hydro-seeded for a burst of color.\n                            Wildflower seed can be selected for full sun, shade, or part shade conditions.\n                            Wildflowers make a wonderful transition from a yard to a wooded area or in community areas of sub-divisions.\n                            They will self-seed, creating a display for years to come.\n                            Wildflowers are typically hydro seeded in the fall or early spring.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/content/hydrob&a.png")
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n                    Hydro seeding is the fastest, most cost effective and highest quality method of\n                    seeding lawn, landscape and erosion control practices. The hydro seeding slurry is\n                    applied with pressure via hose or tower onto the soil to create the ideal\n                    environment for seed germination and turf development.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    The key to successful seed germination in keeping the ground well water until the\n                    seeds begin to sprout. Then maintain a consistent watering regime while the grass fills in.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Grass should start to grow within 7 days, and will be well established\n                    within 3-4 weeks depending on soil type and amount of topsoil on the project.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    The advantages of hydro seeding include faster germination, increased plant survival,\n                    and the ability to cover large, inaccessible areas. The cost is less than that of sod\n                    even over flat areas, and it’s a more viable option in areas that are too steep to apply sod.\n                    Seed applied in a hydro seed mix will generally show growth and develop turf faster than broadcast seed.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "soil-preparation"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Soil Preparation")]), _vm._v(" "), _c('p', [_vm._v("\n                    Soil preparation is important before hydroseeding, if quick results are needed.\n                    Take into consideration the soil type and PH levels, the contour of the land\n                    and moisture content needed for adequate germination.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Gulf Coast is able to prepare the finished ground via giant\n                    discing with or without cultivation. We have lime spreading units that\n                    will bring the soil PH levels to except able standards for quick and even growth.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Top soil can also be imported to sites where dead soil becomes a problem due to the excess depth in borrow pits.\n                    This can resolve problems towards the completion date of bare patches on finished slopes.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "watering"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Watering")]), _vm._v(" "), _c('p', [_vm._v("\n                    With hydroseedings’ ability to retain up to 10 times its weight in water, it’s definitely proved\n                    to be the best method for fast, healthy germination, high plant survival and protection\n                    of seeds with a moisture sealant. No other method of growing grass, whether sod or hand\n                    seeding, has the advantages of hydroseeding when it comes to water retention.\n                    In the hydroseeding mix, fiber mulch and tackifiers are used to anchor the mixture to\n                    slopes and help seal in moisture. The water is then slowly released, along with nutrients,\n                    to the root system to constantly replenish itself until the next rainfall. A hydroseeded\n                    ground starts growing grass from the root first, allowing the root system to go deep into\n                    the ground where moisture is at its greatest, making a very drought-tolerant lawn. On the\n                    contrary, when using sod, the ground has a difficult time establishing a root system making\n                    it weak in drought type conditions, and with hand seeding, the watering demands are\n                    twice as much as a hydroseeded lawn.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "drillseeding"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Drillseeding")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            A seed drill is a device that sows the seeds for grass or crops by metering out the\n                            individual seeds, positioning them in the soil, and covering them to a certain average\n                            depth. The seed drill sows the seeds at equal distances and proper depth, ensuring that\n                            the seeds get covered with soil and are saved from being eaten by birds. Before the\n                            introduction of the seed drill, a common practice was to plant seeds by hand. Besides\n                            being wasteful, planting was usually imprecise and led to a poor distribution of seeds,\n                            leading to low productivity.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/content/drillseeeding.jpg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "silt-fencing"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Silt Fencing")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            A silt fence, sometimes (misleadingly) called a \"filter fence,\" is a temporary sediment\n                            control device used on construction sites to protect water quality in nearby streams,\n                            rivers, lakes and seas from sediment (loose soil) in storm water  runoff.\n                            Silt fences are widely used on construction sites in North America and elsewhere,\n                            due to their low cost and simple design. However, their effectiveness in controlling\n                            sediment can be limited, due to problems with poor installation, proper placement,\n                            and/or inadequate maintenance.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/content/siltfencing.jpg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "erosion-control-blankets"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Erosion Control Blankets")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            Erosion Control Blankets are thick, fibrous blankets woven out of either natural\n                            materials (e.g. straw and coconut fiber), synthetic materials (e.g. polypropylene)\n                            or a mixture of natural and synthetic materials. These blankets are used primarily\n                            to slow water runoff, provide effective sediment and erosion control, and enhance\n                            re-vegetation. These blankets are commonly applied to channel and ditch linings,\n                            slopes, culvert inlets and outfalls, riverbanks, and levees. Erosion control blankets\n                            are classified as short term, long term, or permanent use, mostly based on whether\n                            vegetation is intended to replace or work in conjunction with the blankets.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/content/erosioncontrolblankets.jpg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "erosion-control-logs"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Erosion Control Logs")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            Erosion Control Logs, commonly called wattles, are a very effective sediment control\n                            measure. Available in a variety of sizes: 9\", 12\" and 18\", additional diameters are\n                            available for more severe applications. Erosion Control Logs are contained by a\n                            photodegradable netting which is designed to last at least two construction seasons.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Erosion Control Logs, when properly installed, reduce the rate of water flow,\n                            absorbing water and filtering sediment. A significant amount of sediment will drop\n                            out of the water behind the log during a rain event. Fiber is weed free and naturally\n                            biodegradable, enhancing the soil and helping vegetation become established.\n                            On steep slopes, logs used in conjunction with a properly designed and installed\n                            erosion control blanket results in an effective BMP.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("Advantages")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("Easy to transport and install.")]), _vm._v(" "), _c('li', [_vm._v("Low cost, a single person can usually construct up to 6 a day.")]), _vm._v(" "), _c('li', [_vm._v("A low cost solution to sheet and rill erosion problems.")]), _vm._v(" "), _c('li', [_vm._v("Flexible enough to conform to most applications.")]), _vm._v(" "), _c('li', [_vm._v("Effective at trapping sediment and slowing the velocity of the water.")]), _vm._v(" "), _c('li', [_vm._v("Helps establish and store moisture for native vegetation.")]), _vm._v(" "), _c('li', [_vm._v("\n                                Straw wattles are sterile and seedless, eliminating the introduction of non-native vegetation.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                                Straw wattle will decompose over time allowing regrowth of native vegetation that will help to stabilize the site.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("Plastic netting is photodegradable and straw becomes incorporated into soil.")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/content/erosioncontrollogs.jpg")
    }
  })])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e52c3264"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/services/Hydro.vue
// module id = 164
// module chunks = 1